const templates =  {
    "shop.okraina.ru": {
        title: "Бонусные баллы",
        tags: [

        ]
    },
    "dostavka.okraina.ru": {
        title: "Бонусные баллы",
        tags: [

        ]
    },
}

export default templates;